module.exports = __webpack_public_path__ + "static/media/primaria.fb46efd3.svg";